import { Divider, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React from 'react'
import styles from "../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import globalStyles from "../../../../../assets/styles/global.module.scss";

interface ResetVariableActionProps {
    actionData: any,
}

const ResetVariableAction: React.FC<ResetVariableActionProps> = (props) => {
    
    const { actionData } = props;
    
    return (
        <>
            <Grid container className={`${styles.saveVariableActionMainContainer} ${globalStyles.flexColumn}`} gap={1}>
                <Grid item className={globalStyles.fullwidth}>
                    <Typography className={styles.customAPICallMsgTitle}>Reset Variable</Typography>
                </Grid>
                <Divider />
                <Grid item className={globalStyles.fullwidth}>
                    <TableContainer className={styles.resetVariableTableContainer}>
                        <Table className={styles.resetVariableTable}>
                            <TableHead>
                                <TableRow className={styles.resetVariableHeaderTableRow}>
                                    <TableCell className={styles.resetVariableTableHeaderCell}>Variable</TableCell>
                                    <TableCell className={styles.resetVariableTableHeaderCell}>Value After Reset</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {actionData?.reset_variables?.map((variable: any, index: number) => (
                                    <TableRow key={index}>
                                        <TableCell className={styles.resetVariableTableBodyCell}>
                                            {variable.chatbot_custom_variable_name}
                                        </TableCell>
                                        <TableCell className={styles.resetVariableTableBodyCell}>
                                            {variable.fallback_value}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </>
    )
}

export default ResetVariableAction
